var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"primary-button mr-4",attrs:{"dark":"","color":"custom-primary"}},[_c('v-icon',{attrs:{"left":"","small":""}},[_vm._v("mdi-message-bulleted-off")]),_vm._v(_vm._s(_vm.$t('endChat'))+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }